import React, { FunctionComponent } from "react";

// The line under the selected top-nav tab or icon button, per the Figma "Type=Underline" top-nav variants:
// a separate 2px primary line, as wide as the selected item, on the bar's bottom edge (styled in
// nav_bar_redesign.css). Decorative only: the selected state itself is exposed through aria-current /
// aria-pressed on the item.
const NavBarRedesignSelectionLine: FunctionComponent = () => <span className="NavBarRedesign-selectionLine" aria-hidden="true"/>;

export default NavBarRedesignSelectionLine;
